<template>
	<div style="position: relative;">
		<div style="position: absolute; left:85%;" v-if="status">
			<el-button type="text" @click="status=false">编辑</el-button>
		</div>
		<h3>业绩设置</h3>
		<h4>提成方案公式</h4>
		<div>
			<span style="width:100px; display:inline-block;">完成率：</span>
			<span>实际完成/元（营业额） / 当月业绩指标/元（营业额）</span>
			<div>
				<span style="margin-left:100px">当完成率超过100%时加</span>
				<el-input-number :min='0' class="input_style" v-model="setting.satisfied" size="small"
					:disabled="status" :controls='false' :precision="2"></el-input-number>
				<span>元；当完成率低于</span>
				<el-input-number :min='0' class="input_style" v-model="setting.least" size="small" :disabled="status"
					:controls='false'></el-input-number>
				<span>%不载入统计</span>
			</div>
			<div>
				<span style="width:100px; display:inline-block;">提成/元：</span>
				<span>完成率 * 基数</span>
				<el-input-number :min='0' class="input_style" v-model="setting.base" size="small" :disabled="status"
					:controls='false' :precision="2"></el-input-number>
			</div>
		</div>
		<h3>评价奖惩</h3>
		<div>
			<div v-for="item in setting.comments" :key="item.id">
				<span style="width:150px; display:inline-block;">{{ item.name }}</span>
				<span>奖励金额</span>
				<el-input-number class="input_style" size="small" :disabled="status" v-model="item.reward"
					:controls='false' :precision="2"></el-input-number>
				<span>元</span>
			</div>
		</div>
		<h3>考勤奖惩</h3>
		<div>
			<div>
				<span style="width:100px; display:inline-block;">迟到/早退：</span>
				<el-input-number :min='0' class="input_style" size="small" v-model="setting.lateCenter"
					:disabled="status" :controls='false'></el-input-number>
				<span>分钟内，扣</span>
				<el-input-number :min='0' class="input_style" size="small" v-model="setting.centerBefore"
					:disabled="status" :controls='false' :precision="2"></el-input-number>
				<span>元/每分钟</span>
			</div>
			<div>
				<span style="margin-left:110px">超</span>
				<el-input-number :min='0' class="input_style" size="small" v-model="setting.lateCenter"
					:disabled="status" :controls='false'></el-input-number>
				<span>分钟，扣</span>
				<el-input-number :min='0' class="input_style" size="small" v-model="setting.centerLast"
					:controls='false' :disabled="status" :precision="2"></el-input-number>
				<span>元/每分钟</span>
			</div>
			<div style="margin-left:110px; color:red; font-size: 5px;">
				超过指定时间后的每一分起计，既 {{ setting.lateCenter }} 分钟前扔按规则一计算
			</div>
			<div>
				<span style="width:100px; display:inline-block;">漏打卡：</span>
				<span>
					<el-input-number :min='0' class="input_style" size="small" v-model="setting.actual"
						:disabled="status" :controls='false' :precision="2"></el-input-number>
					<span>元/次，每月最多可补卡</span>
					<el-input-number :min='0' class="input_style" size="small" v-model="setting.repairCount"
						:disabled="status" :controls='false'></el-input-number>
					<span>次</span>
				</span>
			</div>
			<div style="margin-left:110px; color:red; font-size: 5px;">
				补卡仅限当天提交
			</div>
		</div>
		<div style="margin-left:40%" v-if="status==false">
			<el-button type="primary" @click="edit">保存</el-button>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				//页面状态 false.编辑 true.查看
				status: true,
				setting: {},
			}
		},
		methods: {
			edit() {
				this.setting.satisfied = this.setting.satisfied * 100;
				this.setting.base = this.setting.base * 100;
				this.setting.centerBefore = this.setting.centerBefore * 100;
				this.setting.centerLast = this.setting.centerLast * 100;
				this.setting.actual = this.setting.actual * 100;
				this.setting.comments.map(ele => {
					ele.reward = ele.reward * 100
				})
				this.$http.post("dWorker/editSetting", JSON.stringify(this.setting)).then(res => {
					if (res.body.code == 200) {
						this.$message.success("保存成功！");
						this.getSetting();
						this.status = true;
					} else {
						this.$message.error(res.body.msg);
					}
				})
			},
			getSetting() {
				this.$http.get("dWorker/getSetting").then(res => {
					this.setting = res.body.data;
					this.setting.satisfied = this.setting.satisfied / 100;
					this.setting.base = this.setting.base / 100;
					this.setting.centerBefore = this.setting.centerBefore / 100;
					this.setting.centerLast = this.setting.centerLast / 100;
					this.setting.actual = this.setting.actual / 100;
					this.setting.comments.map(ele => {
						ele.reward = ele.reward / 100
					})
				})
			}
		},
		mounted() {
			this.getSetting();
		}
	}
</script>

<style lang="less" scoped>
	.input_style {
		width: 80px;
		margin: 0px 10px;
	}

	div {
		margin-top: 10px;
	}
</style>